define('app/sdc/page/limit/sdc-page-limit',["factory!sdc-page-limit"], function (pageLimit) {
	return {
		priority: 1,
		scope: false,
		template: null,
		controller: {
			bind:{
				"pageLimits": "&sdcPageLimit"
			},
			properties: {
				pageLimit: function pageLimit_get() {
					return pageLimit(this.pageLimits({
						$mdMedia: $mdMedia
					}));
				}
			},
			constructor: ["$attrs", "$watch", function ($attrs, $watch) {
				$watch.group("vm.pageLimits", $attrs.$set.bind($attrs, "pageLimit"));
			}]
		}
	};
});
